export const validate = (value, rules) => {
  let errors = {};

  Object.entries(rules).forEach(([fieldName, fieldRules]) => {
    const fieldValue = value[fieldName];
    const fieldErrors = [];

    Object.entries(fieldRules).forEach(([ruleName, rule]) => {
      const { value: ruleValue, message: ruleMessage } = rule;

      switch (ruleName) {
        case 'min': {
          if (ruleValue !== undefined && fieldValue < ruleValue) {
            fieldErrors.push(ruleMessage);
          }
          break;
        }
        case 'match': {
          if (ruleValue && !ruleValue.test(fieldValue)) {
            fieldErrors.push(ruleMessage);
          }
          break;
        }
      }
    })

    if (fieldErrors.length > 0) {
      errors[fieldName] = fieldErrors;
    }
  });

  if (Object.keys(errors).length === 0) return null;

  return errors;
};

export const hasErrors = (errors) => {
  return !!Object.values(errors).filter((fieldErrors) => fieldErrors.length).length;
}
